import { jsx as _jsx } from "react/jsx-runtime";
/* Generated file. Do not modify. */
import { createElement } from 'react';
import { IconSvg } from '../../icons/IconSvg.js';
export const BarChartIcon = (props) => createElement(IconSvg, {
    ...props,
    viewBox: "0 0 24 24"
}, _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C13.1046 2 14 2.89543 14 4V20C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20V4C10 2.89543 10.8954 2 12 2ZM20 8C21.1046 8 22 8.89543 22 10V20C22 21.1046 21.1046 22 20 22C18.8954 22 18 21.1046 18 20V10C18 8.89543 18.8954 8 20 8ZM6 14C6 12.8954 5.10457 12 4 12C2.89543 12 2 12.8954 2 14V20C2 21.1046 2.89543 22 4 22C5.10457 22 6 21.1046 6 20V14Z", fill: "currentColor" }));
//# sourceMappingURL=BarChartIcon.js.map